import { useFormik } from "formik";
import * as yup from "yup";
import {
  Box,
  TextField,
  MenuItem,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { Edit } from "@mui/icons-material";

const EmployeeForm = ({
  userDetails,
  handleSubmit,
  onBack,
  loading,
  protectEmail = false,
}) => {
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const theme = useTheme();
  const loginValidationSchema = yup.object().shape({
    fullName: yup.string().required("Name is required"),
    email: yup.string().email().required("Email is required"),
    //password: yup.string().required("Password is required"),
    // companyName: yup.string().required("Company Name is required"),
  });

  const formikProps = useFormik({
    enableReinitialize: true,
    initialValues: {
      fullName: userDetails && userDetails.fullName ? userDetails.fullName : "",
      email: userDetails && userDetails.email ? userDetails.email : "",
      phone: userDetails && userDetails.phone ? userDetails.phone : "",
      role: userDetails && userDetails.role ? userDetails.role : "",
      // password: "",
    },
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: loginValidationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <TextField
        disabled={loading}
        label="Full Name"
        value={formikProps.values.fullName}
        onChange={formikProps.handleChange("fullName")}
      />
      <TextField
        disabled={loading || (protectEmail && !isEditingEmail)}
        // disabled={(userDetails != undefined && userDetails != null) || loading}
        label="Email"
        value={formikProps.values.email}
        onChange={formikProps.handleChange("email")}
        InputProps={{
          endAdornment: protectEmail ? (
            <InputAdornment position="start" size="small">
              <IconButton
                onClick={() => {
                  setIsEditingEmail(!isEditingEmail);
                }}
              >
                <Edit size="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
      <TextField
        disabled={loading}
        label="Phone"
        value={formikProps.values.phone}
        onChange={formikProps.handleChange("phone")}
      />
      {!(userDetails && userDetails.role == "OWNER") && (
        <TextField
          select
          disabled={loading}
          label="Role"
          value={formikProps.values.role}
          onChange={formikProps.handleChange("role")}
        >
          <MenuItem value={"ADMIN"}>Admin</MenuItem>
          <MenuItem value={"USER"}>Basic User</MenuItem>
        </TextField>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <LoadingButton
          sx={{ minWidth: 150 }}
          loading={loading}
          variant="outlined"
          onClick={onBack}
        >
          Back
        </LoadingButton>
        <LoadingButton
          sx={{ minWidth: 150, marginLeft: "8px" }}
          loading={loading}
          variant="contained"
          onClick={() => formikProps.handleSubmit()}
        >
          {userDetails ? "Update" : "Create"}
        </LoadingButton>
      </Box>
    </Box>
  );
};
export default EmployeeForm;
